module.exports = __webpack_public_path__ + "img/78600.b98788df.jpg";